import * as z from "zod/v4";

export const deleteReply = {
  name: "deleteReply" as const,
  input: z.object({
    _id: z.string(),
    teamId: z.string(),
    replyIndex: z.number(),
  }),
  output: z.object({ success: z.boolean() }),
};
